import React, { useState, useEffect } from 'react'
import '../navbar/navbar.css'
import Headroom from 'react-headroom'
import { Link, useLocation } from 'react-router-dom'

export const company = "St. Regis Aspen"

const Navbar = () => {
    const [clicked, setClicked] = useState(false)
    const location = useLocation()

    // Collapse mobile menu on route change
    useEffect(() => {
        setClicked(false)
        window.scrollTo({ top: 0, behavior: 'smooth' })
    }, [location.pathname])

    const handleClick = () => {
        setClicked(!clicked)
    }

    const handleClickMenu = () => {
        setClicked(false)
    }

    const isActive = (path) => location.pathname === path

    return (
        <div className='nav fixed-top'>
            <a href="https://niecindonesia.com/" onClick={handleClickMenu}>
                <img src="/img/logo-text-black.png" alt="niec-indonesia" />
            </a>
            <div>
                <ul className={`navbar ${clicked ? '' : 'active'}`}>
                    <li>
                        <Link
                            onClick={handleClickMenu}
                            to='/'
                            className={isActive('/') ? 'nav-active' : ''}
                        >
                            Home
                        </Link>
                    </li>
                    <li>
                        <Link
                            onClick={handleClickMenu}
                            to='/j1-internship'
                            className={isActive('/j1-internship') ? 'nav-active' : ''}
                        >
                            J1 Internship
                        </Link>
                    </li>
                    <li>
                        <Link
                            onClick={handleClickMenu}
                            to='/study-abroad'
                            className={isActive('/study-abroad') ? 'nav-active' : ''}
                        >
                            Study Abroad
                        </Link>
                    </li>
                    <li>
                        <Link
                            className={`home-btn-primary reg${isActive('/j1-internship') || isActive('/study-abroad') ? '' : ''}`}
                            onClick={handleClickMenu}
                            to='/#register'
                            state={{ scrollTo: 'register' }}
                        >
                            Daftar Sekarang
                        </Link>
                    </li>
                </ul>
            </div>
            <div className="hamburger" onClick={handleClick}>
                <i className={`fa-solid ${clicked ? 'fa-xmark' : 'fa-bars'}`}></i>
            </div>
        </div>
    )
}

export default Navbar